import { createAction, props } from '@ngrx/store';
import { CustomerEntity } from './customer.models';
import {
  GetAppointmentsQueryDto,
  IActivity,
  IAppointment,
  ICustomerCredit,
  ILead,
  LoadType,
  NewCustomerDTO,
  UpdateAppointmentDTO,
  UpdateCustomerDTO
} from '@care-portals/api-interfaces';
import { Update } from '@ngrx/entity';

export const createCustomer = createAction(
  '[Customer] Create Customer',
  props<{ customer: NewCustomerDTO; lead?: ILead; goToCustomer?: boolean }>()
);

export const createCustomerSuccess = createAction(
  '[Customer] Create Customer Success',
  props<{ customer: CustomerEntity }>()
);

export const createCustomerFailure = createAction(
  '[Customer] Create Customer Failure',
  props<{ error: any }>()
);

export const loadCustomers = createAction(
  '[Customer] Load Customers',
  props<{ loadType: LoadType; filters: any }>()
);

export const loadCustomersSuccess = createAction(
  '[Customer] Load All Customers Success',
  props<{ customers: CustomerEntity[]; loadType: LoadType }>()
);

export const loadCustomersFailure = createAction(
  '[Customer] Load All Customers Failure',
  props<{ error: any }>()
);

export const loadCustomer = createAction(
  '[Customer] Load Customer',
  props<{ id: string }>()
);

export const loadCustomerSuccess = createAction(
  '[Customer] Load Customer Success',
  props<{ customer: CustomerEntity }>()
);

export const loadCustomerFailure = createAction(
  '[Customer] Load Customer Failure',
  props<{ error: any }>()
);

export const loadCustomerLead = createAction(
  '[Customer] Load Customer Lead',
  props<{ id: string }>()
);

export const loadCustomerLeadSuccess = createAction(
  '[Customer] Load Customer Lead Success',
  props<{ lead: ILead }>()
);

export const loadCustomerLeadFailure = createAction(
  '[Customer] Load Customer Lead Failure',
  props<{ error: any }>()
);

export const loadCustomerActivities = createAction(
  '[Customer] Load Customer Activities',
  props<{ customerId: string }>()
);

export const loadCustomerActivitiesSuccess = createAction(
  '[Customer] Load Customer Activities Success',
  props<{ customerId: string; activities: IActivity[]; hasMore: boolean }>()
);

export const loadCustomerActivitiesFailure = createAction(
  '[Customer] Load Customer Activities Failure',
  props<{ customerId: string; error: any }>()
);

export const createActivitySuccess = createAction(
  '[Customer] Create Activity Success',
  props<{ activity: IActivity }>()
);

export const createActivityFailure = createAction(
  '[Customer] Create Activity Failure',
  props<{ error: any }>()
);

export const openCustomerByBigcommerceId = createAction(
  '[Customer] Open Customer Page by BigcommerceId',
  props<{ bigcommerceId: string }>()
);

export const openCustomerByBigcommerceIdSuccess = createAction(
  '[Customer] Open Customer Page by BigcommerceId Success',
  props<{ customer: CustomerEntity }>()
);

export const updateCustomer = createAction(
  '[Customer] Update Customer',
  props<{ id: string; data: UpdateCustomerDTO }>()
);

export const updateCustomerSuccess = createAction(
  '[Customer] Update Customer Success',
  props<{ customer: Update<CustomerEntity> }>()
);

export const updateCustomerFailure = createAction(
  '[Customer] Update Customer Failure',
  props<{ error: any }>()
);

export const updateCustomerExtras = createAction(
  '[Customer] Update Customer Extras',
  props<{ id: string; extras: any }>()
);

export const updateCustomerExtrasSuccess = createAction(
  '[Customer] Update Customer Extras Success',
  props<{ customer: Update<CustomerEntity> }>()
);

export const updateCustomerExtrasFailure = createAction(
  '[Customer] Update Customer Extras Failure',
  props<{ error: any }>()
);
export const updateWatchlist = createAction(
  '[Customer] Update Watch list',
  props<{ isAdd: boolean; userId?: string }>()
);

export const updateWatchlistFailure = createAction(
  '[Customer] Update Watch list Failure',
  props<{ error: any }>()
);

export const resetCustomers = createAction('[Customer] Reset Customers');

/**
 * Customer Appointment Actions
 */
export const loadAppointments = createAction(
  '[Customer Appointment] Load Appointments',
  props<{ filters: GetAppointmentsQueryDto }>()
);

export const loadAppointmentsSuccess = createAction(
  '[Customer Appointment] Load Appointments Success',
  props<{ appointments: IAppointment[] }>()
);

export const loadAppointmentsFailure = createAction(
  '[Customer Appointment] Load Appointments Failure',
  props<{ error: any }>()
);

export const updateAppointment = createAction(
  '[Customer Appointment] Update Appointment',
  props<{ id: string; appointment: UpdateAppointmentDTO }>()
);

export const updateAppointmentSuccess = createAction(
  '[Customer Appointment] Update Appointment Success',
  props<{ appointment: IAppointment }>()
);

export const updateAppointmentFailure = createAction(
  '[Customer Appointment] Update Appointment Failure',
  props<{ error: any }>()
);

export const loadPaymentMethods = createAction(
  '[Customer] Load Payment Methods',
  props<{ id: string }>()
);

export const loadPaymentMethodsSuccess = createAction(
  '[Customer] Load Payment Methods Success',
  props<{ customerId: string; paymentMethods: any[] }>()
);

export const loadPaymentMethodsFailure = createAction(
  '[Customer] Load Payment Methods Failure',
  props<{ customerId: string; error: any }>()
);

export const nullAction = createAction('[Customer] Null');

export const updateCustomerCredit = createAction(
  '[Customer] Update Customer Credit',
  props<{
    customerId: string;
    amount: number;
    note?: string;
    orderId?: number;
  }>()
);

export const updateCustomerCreditSuccess = createAction(
  '[Customer] Update Customer Credit Success',
  props<{
    customerId: string;
    credit: ICustomerCredit;
  }>()
);

export const updateCustomerCreditFailure = createAction(
  '[Customer] Update Customer Credit Failure',
  props<{ error: any }>()
);
